import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { kebabCase } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';

import { useUser } from '@/modules/common/application/context/user';
import useSidebarNavigation from '@/modules/common/application/use-sidebar-navigation';
import { AccessScope, UserRole } from '@/modules/common/types';

import { getListItemStyles } from './styles';

const DrawerMenu = ({ drawerExpanded }: { drawerExpanded: boolean }) => {
  const { user, company } = useUser();
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  const { getMainNavigation } = useSidebarNavigation();
  const menuItems = getMainNavigation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        margin: '32px 12px 32px 2px',
      }}
    >
      <List>
        {menuItems.map((item) => {
          const { label, to, allowedRoles, Icon, accessScope } = item;
          const isActiveNavItem =
            location.pathname === to || (to !== '/' && location.pathname.startsWith(to));
          const render =
            allowedRoles.includes(user?.role as UserRole) &&
            accessScope?.includes(company?.accessScope as AccessScope);
          return (
            render && (
              <ListItem
                key={to}
                sx={{
                  display: 'flex',
                  py: '4px',
                }}
              >
                <ListItemButton
                  sx={getListItemStyles(theme, drawerExpanded)}
                  selected={isActiveNavItem}
                  onClick={() => navigate(to)}
                  data-cy={`menu-link-${kebabCase(label)}`}
                  aria-label={t(label)}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <SvgIcon
                      component={Icon}
                      inheritViewBox
                      sx={{
                        fontSize: 62,
                        marginTop: 2,
                        justifyContent: 'center',
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    disableTypography
                    sx={{
                      opacity: drawerExpanded ? 1 : 0,
                    }}
                  >
                    {t(label)}
                  </ListItemText>
                </ListItemButton>
              </ListItem>
            )
          );
        })}
      </List>
    </Box>
  );
};

export default DrawerMenu;
